// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1w4_V","footer":"ReportModalFilter_footer__3wmJe"};